import React from 'react';
export function useOverflowDetect() {
    const ref = React.useRef(null);
    const [isOverflowing, setOverflowing] = React.useState(false);
    React.useEffect(() => {
        const element = ref.current;
        if (!element) {
            return;
        }
        const resizeObserver = new ResizeObserver(() => {
            setOverflowing(element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth);
        });
        resizeObserver.observe(element);
        return () => resizeObserver.disconnect();
    }, [ref]);
    return [ref, isOverflowing];
}
